import React, { FC, SVGProps } from 'react';

export const CaretRight: FC<SVGProps<SVGSVGElement>> = ({ fill, ...rest }) => (
  <svg
    width="8"
    height="10"
    viewBox="0 0 8 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M1.8747 9.70024C1.21993 10.2241 0.25 9.75788 0.25 8.91938L0.25 1.08062C0.25 0.242119 1.21993 -0.224054 1.87469 0.299756L6.77391 4.21913C7.27432 4.61946 7.27432 5.38054 6.77391 5.78087L1.8747 9.70024Z"
      fill={fill}
    />
  </svg>
);
